import React from "react";
import styled from "styled-components";

import { DomeText } from "../components/typography";

import NoSyntheticDyes from "../assets/icons/product/no-synthetic-dyes.svg";
import NoSyntheticFragrances from "../assets/icons/product/no-synthetic-fragrance.svg";
import ParabenFree from "../assets/icons/product/paraben-free.svg";
import SiliconeFree from "../assets/icons/product/silicone-free.svg";
import SulfateFree from "../assets/icons/product/sulfate-free.svg";
import OilFree from "../assets/icons/product/oil-free.svg";
import TalcFree from "../assets/icons/product/talc-free.svg";
import PreservativeFree from "../assets/icons/product/preservative-free.svg";
import { Colors } from "./styles/Colors";

const Wrapper = styled.div`
  display: flex;

  flex-direction: column;

  justify-content: center;
  align-items: center;

  text-align: center;

  max-width: 125px;

  margin: 32px 22px;

  > ${DomeText} {
    margin-top: 16px;
    color: ${Colors.cream1};
    font-size: 12px;
  }
`;

const US_TO_UK_MAP = {
  "Sulfate-Free": 'No Sulfates',
  "No Synthetic Dyes": 'No Dyes',
  "Silicone-Free": 'No Silicones',
}

export default function ProductIcon({ icon }) {
  let SVG;

  switch (icon) {
    case "Paraben-Free":
      SVG = ParabenFree;
      break;
    case "Silicone-Free":
      SVG = SiliconeFree;
      break;
    case "Sulfate-Free":
      SVG = SulfateFree;
      break;
    case "No Synthetic Dyes":
      SVG = NoSyntheticDyes;
      break;
    case "No Synthetic Fragrance":
      SVG = NoSyntheticFragrances;
      break;
    case "Talc-Free":
      SVG = TalcFree;
      break;
    case "Preservative-Free":
      SVG = PreservativeFree;
      break;
    case "Oil-Free":
      SVG = OilFree;
      break;
  }

  return (
    <Wrapper>
      <img src={SVG} />
      <DomeText>{process.env.GATSBY_LOCALE === 'en-us' ? icon : (US_TO_UK_MAP[icon] || icon)}</DomeText>
    </Wrapper>
  );
}
